import {put} from 'redux-saga/effects';
import {
  TextViewerData,
  ViewerInfo,
} from '../../../../../../graphql/generated/types';
import {setUrls} from '../state/textViewerSlice';

export function* retrieveUrls({
  productId,
  viewerInfoData,
}: {
  productId: number;
  viewerInfoData: ViewerInfo;
}) {
  const textViewerData: TextViewerData | undefined =
    (viewerInfoData.viewerData || undefined) as TextViewerData;
  if (!textViewerData) {
    return;
  }

  const {atsServerUrl, metaSecureUrl, contentsList} = textViewerData;
  const metaUrl = `${atsServerUrl}${metaSecureUrl}`;
  const contentList = contentsList.map(({chapterId, contentId, secureUrl}) => ({
    chapterId,
    contentId,
    url: `${atsServerUrl}${secureUrl}`,
  }));

  if (metaUrl && contentList) {
    yield put(setUrls({productId, urls: {metaUrl, contentList}}));
  }
}
